import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 16 2",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 2\" id=\"icon-minus\"><path d=\"M0 1h16H0Zm0 1h16V0H0v2Zm16-2H0v2h16V0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol